import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { Button, Grid, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#FFF",
    border: "2px solid #FFF",
    boxShadow: theme.shadows[5],
    //padding: theme.spacing(2, 0, 3),
    width: "450px",
    borderRadius: "3px",
  },
}));

export default function LogoModal({
  openModal,
  setOpenModal,
  onFileChange,
  fileView,
  uploadLogo,
}) {
  const classes = useStyles();
  // const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openModal}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openModal}>
          <div className={classes.paper}>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              item={12}
              alignItems="center"
              style={{ background: "#dcd4e7", borderRadiusTop: "10px" }}
            >
              <Grid item={8}>
                <h5 style={{ marginLeft: "5px" }} id="transition-modal-title">
                  Choose Logo
                </h5>
              </Grid>
              <Grid item={2}>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>

            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              item={8}
              style={{ margin: "10px 0px" }}
            >
              <Grid
                justifyContent="flex-start"
                item={4}
                style={{ position: "relative", top: "68px" }}
              >
                <input
                  id="showFile"
                  style={{
                    border: "none",
                    outline: "none",
                    //display: "none",
                    marginLeft: "5px",
                  }}
                  type="file"
                  accept="image/*"
                  onChange={onFileChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item={4} direction="row" justifyContent="flex-end">
                <div
                  style={{
                    border: "1px solid black",
                    width: "100px",
                    height: "100px",
                    marginLeft: "25px",
                  }}
                >
                  <img
                    src={fileView}
                    style={{ width: "100px", height: "100px" }}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              item={12}
              style={{ marginRight: "70px" }}
              //spacing={2}
            >
              <Grid item style={{ margin: "10px 0px" }}>
                <Button variant="contained" onClick={uploadLogo}>
                  Submit
                </Button>
              </Grid>
              <Grid item style={{ margin: "10px 10px" }}>
                <Button variant="contained" onClick={handleClose}>
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
